import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../context/AuthContext';
import { FaEye, FaEyeSlash, FaUser, FaLock } from 'react-icons/fa';
import LoadingSpinner from '../common/LoadingSpinner';
import './Auth.css';

const Login = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const { register, handleSubmit, formState: { errors } } = useForm();

  const onSubmit = async (data) => {
    setIsLoading(true);
    const result = await login(data);
    setIsLoading(false);
    
    if (result.success) {
      navigate('/dashboard');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <div className="auth-logo">
              
             
             
                <span className="logo-icon">
                   <img src='/logo.png' style={{width: 30, height: 30}}/>
                </span>
                <h1> XPunters </h1>
               
             
                
               
            </div>
            
            <p className="auth-subtitle">Welcome back! Login to your account</p>

          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
             
            <div className="form-group">
              <label>Username or Email</label>
              <div className="input-wrapper">
                
                <input
                  type="text"
                  placeholder="Enter username or email"
                  {...register('username', { required: 'Username is required' })}
                />
              </div>
              {errors.username && (
                <span className="error-message">{errors.username.message}</span>
              )}
            </div>

            <div className="form-group">
              <label>Password</label>
              <div className="input-wrapper">
                 
                <input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter your password"
                  {...register('password', { 
                    required: 'Password is required',
                    minLength: { value: 8, message: 'Password must be at least 8 characters' }
                  })}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              {errors.password && (
                <span className="error-message">{errors.password.message}</span>
              )}
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" /> Remember me
              </label>
              <Link to="/forgot-password" className="forgot-link">
                Forgot password?
              </Link>
            </div>

            <button type="submit" className="auth-button" disabled={isLoading}>
              {isLoading ? <LoadingSpinner size="small" /> : 'Login'}
            </button>

            <div className="auth-divider">
              <span>or</span>
            </div>

            <p className="auth-footer">
              Don't have an account? <Link to="/register">Sign up</Link>
            </p>
           
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;